<template>
    <div class="ht-tab-wrap">
        <b-tabs class="ht-tab-menu wow move-up" @input="shownTab($event)">
            <b-tab :title="$t('tokn.highlights')" active>
                <!-- tab content one component -->
                <TabContentOne />
            </b-tab>
            <b-tab :title="$t('tokn.how_it_works')">
                <!-- tab content two component -->
                <TabContentTwo />
            </b-tab>
            <b-tab :title="$t('tokn.examples')">
                <!-- tab content third component -->
                <TabContentThree />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import TabContentOne from './TabContentOne'
import TabContentTwo from './TabContentTwo'
import TabContentThree from './TabContentThree'

export default {
    name: 'TabOne',
    components: {
        TabContentOne,
        TabContentTwo,
        TabContentThree
    },
    data() {
        return {
            initialTabShown: false
        }
    },
    methods: {
        shownTab(index) {
            if (!this.initialTabShown) {
                this.initialTabShown = true;

                return
            }

            const data = [
                ["Highlights / Features", "#highlights"],
                ["How it works", "#how-it-works"],
                ["Examples", "#examples"]
            ][index];

            this.$root.$emit('pageview', data[1], data[0]);
        }
    }
};
</script>
